// extracted by mini-css-extract-plugin
module.exports = {"root":"ComingSoon_root__3ASFc","header":"ComingSoon_header__ATnov","text":"ComingSoon_text__VywnY"};